<template>
  <QuestionBase :question="question" :errors="[...serverErrors, ...jsErrors]" :valid="!!data" >
      <InputRadio
          v-model="data"
          :options="expectationsOptions"
          :db="db"
          :args="args"
          :skipped="skipped"
          class="radio-options-wide"
          @skipped="skipped=$event"
          @serverErrors="serverErrors=$event"
          @jsErrors="jsErrors=$event"
      />
  </QuestionBase>
</template>

<script>
import { questionLoadHelpers} from "../../helpers/questionLoadHelpers";
import { feedbackOptions } from "../../options/feedbackOptions";

import QuestionBase from "../../QuestionBase";
import InputRadio from "../../inputs/InputRadio";

export default {
  name: 'Expectations',
  mixins: [feedbackOptions, questionLoadHelpers],
  components: {
    InputRadio,
    QuestionBase
  },
  props: {
    value: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: false
    },
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input', value)
      },
      get () {
        return this.value
      }
    }
  },
  data () {
    return {
      question: {
        title:  'Did the service meet your expectations?',
        subTitle:  null,
        tip: null
      },
      db: {
        saveLocation: 'feedback_save',
        saveField: 'expectations_met'
      },
      args: {
        skippable: false,
        required: true,
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>
